//Development-Production
import * as BelfastpilatesDevelopmentappspotcom from "belfastpilates_developmentappspotcom";
import * as BelfastpilatesProductionappspotcom from "belfastpilates_productionappspotcom";

let clientLibsToExport = BelfastpilatesDevelopmentappspotcom;

// console.log(process.env.NODE_ENV);
if (process.env.NODE_ENV === "production") {
  clientLibsToExport = BelfastpilatesProductionappspotcom;
} else if (process.env.NODE_ENV === "development") {
  clientLibsToExport = BelfastpilatesDevelopmentappspotcom;
} else {
  clientLibsToExport = BelfastpilatesDevelopmentappspotcom;
}

export { clientLibsToExport as Belfastpilatesappspotcom };



// WEBPACK FOOTER //
// ./src/common/ClientLibsReference.js